import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { TextList, TextListItem } from '@oneaudi/unified-web-components';
import { useFootnoteReferenceState } from '../hooks/useFootnoteReferenceState';
import { useServicesContext } from '../../../context';
import { DangerousElement } from '../../DangerousElement';
export const FootnotesReferenceText = () => {
    const { references } = useFootnoteReferenceState();
    const footnoteService = useServicesContext().getAdditionalService('audi-footnote-service');
    const containerRef = useRef(null);
    const [footnoteData, setFootnoteData] = useState(() => { var _a; return (_a = footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.getData()) !== null && _a !== void 0 ? _a : []; });
    useEffect(() => {
        if (!footnoteService)
            return undefined;
        setFootnoteData(footnoteService.getData());
        footnoteService.unregisterCallback();
        footnoteService.registerCallback((data) => {
            setFootnoteData(data !== null && data !== void 0 ? data : []);
        });
        return () => {
            footnoteService.unregisterCallback();
        };
    }, [footnoteService]);
    useEffect(() => {
        const handleFootnoteLinkClick = (evt) => {
            var _a;
            const link = evt.target.closest('.audi-j-footnote-reference');
            if (!link)
                return;
            const href = link.getAttribute('href');
            if (!(href === null || href === void 0 ? void 0 : href.startsWith('#')))
                return;
            const targetEl = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`#${href.slice(1)}`);
            if (!targetEl)
                return;
            evt.preventDefault();
            evt.stopPropagation();
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        };
        document.addEventListener('click', handleFootnoteLinkClick, true);
        return () => document.removeEventListener('click', handleFootnoteLinkClick, true);
    }, []);
    const activeReferences = references.filter((ref) => typeof ref.number === 'number' && ref.number > 0);
    if (!activeReferences.length || !footnoteData.length)
        return null;
    const matchedFootnotes = activeReferences
        .map((ref) => {
        const footnote = footnoteData.find((f) => f.Key === ref.id || f.Key === ref.id.replace(/^ft_/, ''));
        return footnote ? Object.assign(Object.assign({}, footnote), { number: ref.number, contextId: ref.contextId }) : null;
    })
        .filter(Boolean)
        .sort((a, b) => a.number - b.number);
    if (!matchedFootnotes.length)
        return null;
    return (React.createElement(FootnoteEngineStyledContainer, { ref: containerRef, className: "audi-footnote-engine" },
        React.createElement(TextList, { size: "sm", variant: "decimal" }, matchedFootnotes.map((footnote) => (React.createElement(TextListItem, { key: `footnote-${footnote.number}-${footnote.Key}` },
            React.createElement("p", { id: footnote.contextId },
                React.createElement(DangerousElement, { as: "span", html: footnote.Text }))))))));
};
export const handleFootnoteLinkClick = (evt) => {
    const link = evt.target.closest('.audi-j-footnote-reference');
    if (!link)
        return;
    evt.stopPropagation();
    evt.preventDefault();
    const href = link.getAttribute('href');
    if (!(href === null || href === void 0 ? void 0 : href.startsWith('#')))
        return;
    const targetEl = evt.currentTarget.querySelector(`#${href.slice(1)}`);
    if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
};
export const FootnoteEngineStyledContainer = styled.div `
  background-color: transparent;

  a {
    color: inherit;
    font-weight: bold;
  }
`;
